import { c as _c } from "react/compiler-runtime";
import { NumberField, NumberFieldProps, Title } from "@justhome/react-ui";
import useLanguage from "@lib/hooks/useLanguage";
import { Control, FieldPath, FieldValues, useController, UseControllerProps } from "react-hook-form";
export interface RangeInputExtraProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  rules?: UseControllerProps<TFieldValues, FieldPath<TFieldValues>>["rules"];
  defaultValue?: [number, number];
}
type RangeInputProps<TFieldValues extends FieldValues> = RangeInputExtraProps<TFieldValues> & Omit<NumberFieldProps, "ref" | "name" | "defaultValue">;
const RangeInput = t0 => {
  const $ = _c(46);
  let control;
  let name;
  let props;
  let rules;
  if ($[0] !== t0) {
    ({
      control,
      name,
      rules,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = control;
    $[2] = name;
    $[3] = props;
    $[4] = rules;
  } else {
    control = $[1];
    name = $[2];
    props = $[3];
    rules = $[4];
  }
  let t1;
  if ($[5] !== control || $[6] !== name || $[7] !== rules) {
    t1 = {
      name,
      control,
      rules
    };
    $[5] = control;
    $[6] = name;
    $[7] = rules;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const {
    field: t2,
    fieldState: t3,
    formState: t4
  } = useController(t1);
  const {
    onChange,
    onBlur,
    value: t5,
    ref
  } = t2;
  let t6;
  if ($[9] !== t5) {
    t6 = t5 === undefined ? [0, 0] : t5;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const value = t6;
  const {
    isTouched,
    invalid,
    error
  } = t3;
  const {
    isSubmitted
  } = t4;
  let label;
  let restProps;
  if ($[11] !== props) {
    ({
      label,
      ...restProps
    } = props);
    $[11] = props;
    $[12] = label;
    $[13] = restProps;
  } else {
    label = $[12];
    restProps = $[13];
  }
  const [t7, t8] = value;
  const minValue = t7 === undefined ? "" : t7;
  const maxValue = t8 === undefined ? "" : t8;
  const adjustedMinValue = minValue === 0 ? undefined : minValue;
  const adjustedMaxValue = maxValue === 0 ? undefined : maxValue;
  let t9;
  if ($[14] !== maxValue || $[15] !== onChange) {
    t9 = val => {
      onChange([val, maxValue]);
    };
    $[14] = maxValue;
    $[15] = onChange;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const handleMinChange = t9;
  let t10;
  if ($[17] !== minValue || $[18] !== onChange) {
    t10 = val_0 => {
      onChange([minValue, val_0]);
    };
    $[17] = minValue;
    $[18] = onChange;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const handleMaxChange = t10;
  const locale = useLanguage();
  const isInvalid = (isTouched || isSubmitted) && invalid;
  const errorMessage = error?.message;
  let t11;
  if ($[20] !== label) {
    t11 = <Title as="span" className="mb-xs flex text-title-1">{label}</Title>;
    $[20] = label;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = isInvalid ? errorMessage : undefined;
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = ["de", "immo"];
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = t13.includes(locale);
  let t15;
  if ($[23] !== adjustedMinValue || $[24] !== handleMinChange || $[25] !== onBlur || $[26] !== restProps || $[27] !== t12 || $[28] !== t14) {
    t15 = <NumberField value={adjustedMinValue} onChange={handleMinChange} onBlur={onBlur} errorMessage={t12} germanLocale={t14} {...restProps} />;
    $[23] = adjustedMinValue;
    $[24] = handleMinChange;
    $[25] = onBlur;
    $[26] = restProps;
    $[27] = t12;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <span style={{
      margin: "0 8px"
    }}>–</span>;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const t17 = isInvalid ? errorMessage : undefined;
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = ["de", "immo"];
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  const t19 = t18.includes(locale);
  let t20;
  if ($[32] !== adjustedMaxValue || $[33] !== handleMaxChange || $[34] !== onBlur || $[35] !== restProps || $[36] !== t17 || $[37] !== t19) {
    t20 = <NumberField value={adjustedMaxValue} onChange={handleMaxChange} onBlur={onBlur} errorMessage={t17} germanLocale={t19} {...restProps} />;
    $[32] = adjustedMaxValue;
    $[33] = handleMaxChange;
    $[34] = onBlur;
    $[35] = restProps;
    $[36] = t17;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t15 || $[40] !== t20) {
    t21 = <div className="flex items-center">{t15}{t16}{t20}</div>;
    $[39] = t15;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== ref || $[43] !== t11 || $[44] !== t21) {
    t22 = <div ref={ref} className="flex flex-col">{t11}{t21}</div>;
    $[42] = ref;
    $[43] = t11;
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  return t22;
};
export default RangeInput;